/* eslint-disable react/no-did-update-set-state */
/* eslint-disable no-nested-ternary */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage, injectIntl } from 'react-intl';
import SectionHeader from '../../../components/sectionHeader';
import icon from '../../../icons/badging.png';
import fstyles from '../../Maintenance/inspections.module.scss';
import Table from './Table';
import { fetchApplications, fetchReviewedApplications, clearApplicationDetails, getSchema } from '../redux/actions';
import Clickable from '../../../components/clickable/Clickable';
import Button from '../../../components/button';
import Loading from '../../../components/loading';


class BadgeList extends Component {
  state = {
    activeTab: 'pending',
    loadingStatus: false
  };

  componentDidMount() {
    const {
      actionFetchApplications,
      actionFetchReviewedApplications,
      actionFetchSchema
    } = this.props;

    this.setState({ loadingStatus: true });

    actionFetchApplications();
    actionFetchReviewedApplications();
    actionFetchSchema();
  }

  componentDidUpdate(prevProps) {
    const { deleteAction, fetchApplicationAction, actionFetchApplications, fetchReviewedApplicationAction,
    actionFetchReviewedApplications } = this.props;

    // Stop loader when API completes
    if (
      (prevProps.fetchApplicationAction?.loading && !fetchApplicationAction?.loading)
      || (prevProps.fetchReviewedApplicationAction?.loading && !fetchReviewedApplicationAction?.loading)
    ) {
      if (!fetchApplicationAction?.loading && !fetchReviewedApplicationAction?.loading) {
        this.setState({ loadingStatus: false });
      }
    }

    // Refresh data after delete (no full reload)
    if (!prevProps.deleteAction.success && deleteAction.success) {
      this.setState({ loadingStatus: true });
      actionFetchApplications();
      actionFetchReviewedApplications();
    }
  }

  componentWillUnmount() {
    const { clearApplicationList } = this.props;
    clearApplicationList();
  }

  setActiveTab = (activeTab) => {
    this.setState({ activeTab });
  };

  getFilteredApplications = () => {
    const { applications, reviewed_applications } = this.props;
    const { activeTab } = this.state;

    switch (activeTab) {
      case 'completed':
        return (
          reviewed_applications?.filter(
            app => app.current_stage === 'completed' && app.status === 1
          ) || []
        );

      case 'expired':
        return applications?.filter(app => app.status === 7) || [];

      case 'lost':
        return (
          applications?.filter(app => [8, 9, 10].includes(app.status)) || []
        );

      case 'closed':
        return applications?.filter(app => app.status === 11) || [];

      case 'pending':
      default:
        return (
          applications?.filter(
            app => app.current_stage !== 'completed'
              && ![1, 7, 8, 9, 10, 11].includes(app.status)
          ) || []
        );
    }
  };

  initiateApplication = () => {
    const { history, badgeSettings } = this.props;

    if (
      badgeSettings?.settings?.application_fill_up_portal
      === 'signatory_staff'
    ) {
      history.push('/badging/form');
    } else if (
      badgeSettings?.settings?.application_fill_up_portal
      === 'applicant'
    ) {
      history.push('/badging/new');
    } else {
      history.push('/badging/select');
    }
  };

  render() {
    const { user } = this.props;
    const { activeTab, loadingStatus } = this.state;

    const filtered_applications = this.getFilteredApplications();

    return (
      <>
        <Loading loadingStatus={loadingStatus} zindex="1000" />

        <SectionHeader
          icon={icon}
          translationID="shortcuts.badge"
          defaultTitle="Badge Requests"
        >
          <div className={fstyles.detailHeader}>
            <div className={fstyles.navigation}>
              <Clickable
                className={activeTab === 'pending' ? fstyles.active : ''}
                onClick={() => this.setActiveTab('pending')}
              >
                <FormattedMessage
                  id="maintenance.active"
                  defaultMessage="Pending"
                />
              </Clickable>

              <Clickable
                className={activeTab === 'completed' ? fstyles.active : ''}
                onClick={() => this.setActiveTab('completed')}
              >
                <FormattedMessage
                  id="maintenance.closed"
                  defaultMessage="Completed"
                />
              </Clickable>

              <Clickable
                className={activeTab === 'expired' ? fstyles.active : ''}
                onClick={() => this.setActiveTab('expired')}
              >
                <FormattedMessage
                  id="document.table.expired"
                  defaultMessage="Expired"
                />
              </Clickable>

              <Clickable
                className={activeTab === 'lost' ? fstyles.active : ''}
                onClick={() => this.setActiveTab('lost')}
              >
                <FormattedMessage
                  id="document.table.expiredddd"
                  defaultMessage="Lost/Damaged/Returned"
                />
              </Clickable>

              <Clickable
                className={activeTab === 'closed' ? fstyles.active : ''}
                onClick={() => this.setActiveTab('closed')}
              >
                <FormattedMessage
                  id="document.table.closed"
                  defaultMessage="Closed"
                />
              </Clickable>
            </div>

            <Button
              translationID="badge.initiate"
              defaultText="Initiate Application"
              onClick={this.initiateApplication}
            />
          </div>
        </SectionHeader>

        <div style={{ display: 'flex' }} className={fstyles.toolbar}>
          <div className={fstyles.counter}>
            {activeTab === 'pending' ? (
              <FormattedMessage
                id="badging.list.open"
                defaultMessage="All Badges"
              />
            ) : activeTab === 'completed' ? (
              <FormattedMessage
                id="badging.list.close"
                defaultMessage="All Completed Badges"
              />
            ) : activeTab === 'expired' ? (
              <FormattedMessage
                id="badging.list.expired"
                defaultMessage="All Expired Badges"
              />
            ) : activeTab === 'closed' ? (
              <FormattedMessage
                id="badging.list.close"
                defaultMessage="All Closed Badges"
              />
            ) : (
              <FormattedMessage
                id="badging.list.expiredddd"
                defaultMessage="All Lost/Damaged/Returned Badges"
              />
            )}

            <span className={fstyles.number}>
              {filtered_applications?.length}
            </span>
            <span className={fstyles.req}>Requests</span>
          </div>
        </div>

        <div className={fstyles.container}>
          {filtered_applications?.length > 0 ? (
            <Table
              info={filtered_applications}
              permissions={user?.permissions}
            />
          ) : (
            <span className={fstyles.spanStyle}>
              <FormattedMessage
                id="badging.list"
                defaultMessage="There are no applications with the selected criteria."
              />
            </span>
          )}
        </div>
      </>
    );
  }
}

BadgeList.propTypes = {
  match: PropTypes.shape({}).isRequired,
  history: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  currentModule: state.general.currentModule,
  user: state.auth.profile,
  applications: state.badging.applications,
  reviewed_applications: state.badging.reviewed_applications,
  deleteAction: state.badging.deleteAction,
  fetchApplicationAction: state.badging.fetchApplicationAction,
  badgeSettings: state.badging.schema,
  fetchReviewedApplicationAction: state.badging.fetchReviewedApplicationAction
});

const mapDispatchToProps = dispatch => ({
  actionFetchApplications: () => {
    dispatch(fetchApplications());
  },
  actionFetchReviewedApplications: () => {
    dispatch(fetchReviewedApplications());
  },
  clearApplicationList: () => {
    dispatch(clearApplicationDetails());
  },
  actionFetchSchema: () => {
    dispatch(getSchema());
  }
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(injectIntl(BadgeList));
